import React from 'react'

const CheckMarkIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M21.8006 10.0005C22.2573 12.2418 21.9318 14.5719 20.8785 16.6023C19.8251 18.6326 18.1075 20.2405 16.0121 21.1578C13.9167 22.0751 11.5702 22.2463 9.36391 21.6428C7.15758 21.0394 5.2248 19.6979 3.88789 17.8419C2.55097 15.9859 1.89073 13.7277 2.01728 11.4439C2.14382 9.16001 3.04949 6.98857 4.58326 5.29165C6.11703 3.59473 8.18619 2.47491 10.4457 2.11893C12.7052 1.76295 15.0184 2.19234 16.9996 3.33548" stroke="#003726" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M9 11L12 14L22 4" stroke="#003726" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default CheckMarkIcon